module.exports = __webpack_public_path__ + "static/media/fah-chartered-acc.877e7cd9.png";